// removed by extract-text-webpack-plugin
module.exports = {"loadingState":"G0ffad2"};